import React from "react";
import PropTypes from "prop-types";

import Star from "@components/Star";

import { css } from "@oddcommon/utils";
import styles from "./Rule.module.scss";

export default function Rule({ children, className, star, ...props }) {
  return (
    <div className={css(styles.base, className)} {...props}>
      {star && (
        <div className={styles.starContainer}>
          <Star spec="sm" className={styles.star} />
        </div>
      )}

      <div className={styles.clipContainer}>
        {children && <p className="eyebrow">{children}</p>}
        <div className={styles.line} />
      </div>
    </div>
  );
}

Rule.propTypes = {
  children: PropTypes.node,
  star: PropTypes.bool,
};
Rule.defaultProps = {
  text: null,
  star: true,
};
